import { render, staticRenderFns } from "./GsCalendarDayContent.vue?vue&type=template&id=c61dc028&scoped=true&"
import script from "./GsCalendarDayContent.vue?vue&type=script&lang=js&"
export * from "./GsCalendarDayContent.vue?vue&type=script&lang=js&"
import style0 from "./GsCalendarDayContent.vue?vue&type=style&index=0&id=c61dc028&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61dc028",
  null
  
)

export default component.exports